import { PricePlan } from 'common/types/OfferInterface'
import EntityTypeEnum from '../../enums/entityTypeEnum'
import { CurrencyEnum } from '../CurrencyType'
import { PaddingType } from '../styleTypes'
import { EntityInterface } from './EntityInterface'

interface ProductEntityInterface extends EntityInterface {
  type: EntityTypeEnum.Product
  padding: PaddingType
  mobilePadding: PaddingType
  showQuantity: boolean
  fontFamily?: string
  fontStyle?: string
  fontWeight?: string
  mobileFontFamily?: string
  mobileFontStyle?: string
  mobileFontWeight?: string
  fontFileId?: number
  mobileFontFileId?: number
  showStockLimit?: boolean
}

export default ProductEntityInterface

export interface ProductOptionInterface {
  id: string
  name: string
  optionValues: ProductOptionValueInterface[]
}

export interface ProductOptionValueInterface {
  id: string
  value: string
}

export interface ProductInterface {
  id: number
  name: string
  tax: number
  sku: string
  currency: CurrencyEnum
  price: number
  pricePlan: PricePlan
  description?: string
  images: ImageFileInterface[]
  options: ProductOptionInterface[]
  productVariants: ProductVariantInterface[]
  limitStock?: boolean
  stock?: number
}

interface Resources {
  id: number
  type: string
  value: string
}

export interface DigitalProductInterface {
  id: number
  name: string
  resources: Resources[]
}

export enum DigitalProductResourcesTypeEnum {
  BookingEvent = 'booking_event',
}

export interface ImageFileInterface {
  id: number
  path: string
}

export interface ProductVariantInterface {
  id: string
  sku?: string
  price?: number
  optionValueIds: string[]
  productOptionValues: ProductOptionValueInterface[]
  image?: ImageFileInterface
  stock?: number
}

export interface OfferThankYouProductInterface {
  name: string
  quantity: number
  currency: CurrencyEnum
  price: string
  variant?: ProductOptionValueInterface[]
}

export interface ProductBumpInfoInterface {
  name: string
  price: string
  priceAmount: number
  priceWithoutTaxAndCurrency: number
  taxPercent: number
  taxAmount: number
  currency: CurrencyEnum
}

export interface ProductInfoInterface {
  name: string
  priceWithTaxAndCurrency: string
  netPrice: number
  variantDescription?: string
  currency: CurrencyEnum
  priceWithoutTaxAndCurrency: number
  taxPercent: number
  taxAmount: number
}
